import React, { useEffect, useState } from "react";

const languages = [
    { code: "en", label: "English", flag: "https://flagcdn.com/w20/us.png" },
    { code: "ar", label: "Arabic", flag: "https://flagcdn.com/w20/sa.png" },
    { code: "zh-CN", label: "Chinese (Simplified)", flag: "https://flagcdn.com/w20/cn.png" },
    { code: "fr", label: "French", flag: "https://flagcdn.com/w20/fr.png" },
    { code: "de", label: "German", flag: "https://flagcdn.com/w20/de.png" },
    { code: "id", label: "Indonesian", flag: "https://flagcdn.com/w20/id.png" },
    { code: "it", label: "Italian", flag: "https://flagcdn.com/w20/it.png" },
    { code: "ja", label: "Japanese", flag: "https://flagcdn.com/w20/jp.png" },
    { code: "ko", label: "Korean", flag: "https://flagcdn.com/w20/kr.png" },
    { code: "pt", label: "Portuguese (Brazil)", flag: "https://flagcdn.com/w20/br.png" },
    { code: "ru", label: "Russian", flag: "https://flagcdn.com/w20/ru.png" },
    { code: "es", label: "Spanish", flag: "https://flagcdn.com/w20/es.png" }
];

const GoogleTranslate = () => {
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(languages[0]); // Default English

    useEffect(() => {
        const style = document.createElement("style");
        style.textContent = `
      .goog-te-combo, .goog-te-banner-frame, .goog-te-gadget { display:none !important; }
    `;
        document.head.appendChild(style);
    }, []);

    const changeLanguage = (item) => {
        const select = document.querySelector(".goog-te-combo");

        setSelected(item); // UI update

        if (select) {
            select.value = item.code;
            select.dispatchEvent(new Event("change"));
        }

        // Fix for English reset
        if (item.code === "en") {
            setTimeout(() => {
                setSelected(languages[0]);
                if (select) {
                    select.value = "";
                    select.dispatchEvent(new Event("change"));
                }
            }, 300);
        }

        setOpen(false);
    };

    return (
        <div style={{ position: "relative", display: "inline-block" }}>

            {/* SELECTED BUTTON */}
            <div
                onClick={() => setOpen(!open)}
                style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "8px 12px",
                    borderRadius: "10px",
                    border: "1px solid #999",
                    background: "#fff",
                    width: "auto",
                    justifyContent: "space-between"
                }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <img
                        src={selected.flag}
                        style={{ width: 22, height: 22, borderRadius: "50%" }}
                    />
                    <span>{selected.label}</span>
                </div>
                <span>▼</span>
            </div>

            {/* DROPDOWN MENU */}
            {open && (
                <div
                    style={{
                        position: "absolute",
                        top: "50px",
                        right: "0px",
                        width: "240px",
                        background: "#fff",
                        borderRadius: "10px",
                        border: "1px solid #ddd",
                        boxShadow: "0px 6px 18px rgba(0,0,0,0.15)",
                        maxHeight: "300px",
                        overflowY: "auto",
                        zIndex: 99999
                    }}
                >
                    {languages.map((item) => (
                        <div
                            key={item.code}
                            onClick={() => changeLanguage(item)}
                            style={{
                                padding: "10px 14px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                borderBottom: "1px solid #f3f3f3",
                                background:
                                    selected.code === item.code ? "rgba(255,0,0,0.08)" : "white"
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                <img
                                    src={item.flag}
                                    style={{ width: 22, height: 22, borderRadius: "50%" }}
                                />
                                {item.label}
                            </div>

                            {/* ✔ Checkmark - show only on selected */}
                            {selected.code === item.code && (
                                <span style={{ color: "green", fontSize: "16px", fontWeight: "bold" }}>
                                    ✔
                                </span>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default GoogleTranslate;
